import React from 'react';

const FOUNDER_IMG =
  'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/06hto7fa_image.png';

const FounderStorySection = () => {
  return (
    <section id="founder-story" className="bg-[#EDE6DB]">
      <div className="grid grid-cols-1 md:grid-cols-[1.15fr_0.85fr] min-h-[520px] md:min-h-[720px]">
        {/* Left: full-bleed founder photo */}
        <div className="relative overflow-hidden min-h-[340px]">
          <img
            src={FOUNDER_IMG}
            alt="Archen™'s founder at work in the studio"
            data-testid="founder-photo"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: 'grayscale(1) contrast(1.08) brightness(0.98)' }}
          />
        </div>

        {/* Right: story copy on cream */}
        <div className="flex items-center px-8 md:px-12 lg:px-14 py-16 md:py-24 animate-[fadeUp_0.8s_ease-out_both]">
          <div className="max-w-[520px]">
            <p className="text-[#7A5A2E] text-[12px] tracking-[0.24em] uppercase mb-8">Founder story</p>
            <h2
              className="text-[#1F1812] leading-[1.08] tracking-[-0.02em] mb-8"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontWeight: 500,
                fontSize: 'clamp(2.2rem, 3.8vw, 3.2rem)',
              }}
            >
              Built by someone
              <br />
              who lived the problem.
            </h2>
            <div className="space-y-5 text-[#4A3F33] text-[16px] leading-[1.8]">
              <p>
                Archen™ was born from years inside design and architecture workflows, where the most
                valuable project knowledge was often trapped in emails, meetings, screenshots, PDFs,
                and people's heads.
              </p>
              <p>The question became simple:</p>
              <p
                className="text-[#1F1812]"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500, fontStyle: 'italic', fontSize: '19px' }}
              >
                "Why does every project force us to relearn what we already know?"
              </p>
              <p>Archen™ exists to make sure firms don't lose their memory as they grow.</p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};

export default FounderStorySection;
